export interface MessageImage {
  id: string;
  url: string;
  width?: number;
  height?: number;
}

export enum MessageType {
  USER_MESSAGE = 'USER_MESSAGE',
  WANT_LIST_REMINDER = 'WANT_LIST_REMINDER',
  EMAIL_VERIFICATION_REMINDER = 'EMAIL_VERIFICATION_REMINDER',
  PHONE_VERIFICATION_REMINDER = 'PHONE_VERIFICATION_REMINDER',
  TRADE_REMINDER_SHIP = 'TRADE_REMINDER_SHIP',
  TRADE_REMINDER_COMPLETE = 'TRADE_REMINDER_COMPLETE'
}

export interface Message {
  id: string;
  sender: {
    id: number;
    username: string;
    avatarUrl?: string;
    country?: string | null;
  } | null;
  content: string;
  createdAt: string;
  isRead: boolean;
  type?: MessageType;
  isSystemMessage?: boolean;
  images?: MessageImage[];
}

export interface Conversation {
  conversationId: string;
  otherUser: {
    id: number;
    username: string;
    avatarUrl?: string;
    country?: string | null;
  };
  lastMessage: string;
  lastMessageAt: string;
  unreadCount: number;
  isRead: boolean;
}

export interface InboxResponse {
  conversations: Conversation[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    hasMore: boolean;
  };
}

export interface ConversationThread {
  conversationId: string;
  otherUser: {
    id: number;
    username: string;
    avatarUrl?: string;
    country?: string | null;
  };
  messages: Message[];
  imageCount?: number;
}

export interface NotificationSettings {
  emailOnNewMessage: boolean;
  emailOnNewTrade: boolean;
  emailOnSystemMessage: boolean;
  emailOnNewFeatures: boolean;
  soundEnabled: boolean;
}

// WebSocket event payload interfaces

/**
 * Payload for 'message:new' socket event
 * Emitted to recipient when a new message is sent
 */
export interface NewMessagePayload {
  conversationId: string;
  messageId: string;
  sender: {
    id: number;
    username: string;
    avatarUrl?: string;
    country?: string;
  };
  content: string;
  createdAt: string;
  type: 'USER' | 'SYSTEM';
  images?: MessageImage[];
}

/**
 * Payload for 'message:read' socket event
 * Emitted to sender when recipient reads messages (debounced 500ms)
 */
export interface MessageReadPayload {
  conversationId: string;
  readerId: number;
  readerUsername: string;
  messageIds: string[];
  readAt: string;
}

/**
 * Payload for 'notifications:update' socket event
 * Emitted when badge counts change
 */
export interface NotificationCountsPayload {
  userId: number;
  inboxCount: number;
  receivingCount: number;
  hasOverdueTrades: boolean;
}

/**
 * Extended Message interface with read receipt timestamp
 */
export interface MessageWithReadReceipt extends Message {
  readAt?: string;
}
